import React from "react";

const ContactForm: React.FC = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light leading-tight mb-6">
          Ready to test ideas faster?
        </h2>
        <p className="text-lg text-gray-600 mb-8 leading-relaxed">
          Book a free call to discuss how we can help your strategy team build and
          test new ideas rapidly.
        </p>
        <a
          href="https://calendly.com/rohansontakke/30min"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-gray-900 text-white px-8 py-4 rounded-lg font-semibold hover:bg-gray-800 transition-colors"
        >
          Book a call →
        </a>
      </div>
    </section>
  );
};

export default ContactForm;
